// src/utils/format.js

/**
 * Format a number as currency with proper decimal places
 * @param {number} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @param {string} currency - Currency symbol (default: 'R')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, decimals = 2, currency = "R") => {
  if (value === undefined || value === null || isNaN(value)) {
    return `${currency}0.00`;
  }

  const num = Number(value);
  const formatted = num.toFixed(decimals);

  // If it's a whole number (e.g., 349.00), show as 349.00
  // If it has cents, show with 2 decimal places
  return `${currency}${formatted}`;
};

/**
 * Format a number with commas for thousands
 * @param {number} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number
 */
export const formatNumber = (value, decimals = 2) => {
  if (value === undefined || value === null || isNaN(value)) {
    return "0.00";
  }

  const num = Number(value);
  return num.toLocaleString("en-ZA", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

/**
 * Format price with Rand symbol and proper decimal places
 * @param {number} price - The price to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted price
 */
export const formatPrice = (price, decimals = 2) => {
  if (price === undefined || price === null || isNaN(price)) {
    return "R0.00";
  }

  const num = Number(price);
  return `R${num.toFixed(decimals)}`;
};

// Use this in your components instead of the inline formatPrice functions
